import * as Sentry from '@sentry/nextjs';
import { Logger } from '@icommerce/logger';

export const nextApiCallErrorFn = (err: unknown, msg: string) => {
  const errorObject = err as Record<string, string>;
  const message = errorObject?.message ?? JSON.stringify(err);

  Logger.error({ message, error: err }, 'NextApiCallError');
  Sentry.captureException(new Error(`${msg}: ${message}`));
};
